import { AllowFeature } from 'app/model/feature/allow-feature.model';
import { CostCenterAddressModel } from '../checkout/cost-center-address.model';

export class CostCenterFeature extends AllowFeature {
    public costCenter: String;
    public costCenterName: String;
    public defaultAddress: CostCenterAddressModel;
    public getTaxAddressByAPI: Boolean;
    public displayTaxAddressByDropdown: Boolean;
    public label: labelLanguage;

    constructor(featureData: any = undefined) {
        const isRequired = featureData && featureData.required === 'true';
        const isDisplayed = featureData && featureData.display === 'true';
        super(isRequired, isDisplayed);
        this.getTaxAddressByAPI = featureData && featureData.getTaxAddressByAPI === 'true';
        this.displayTaxAddressByDropdown = featureData && featureData.displayTaxAddressByDropdown === 'true';
        this.label = featureData && featureData.label ? featureData.label : null;
        if (isDisplayed) {
            this.costCenter = featureData.defaultCode && featureData.defaultCode.trim();
            this.costCenterName = featureData.defaultName && featureData.defaultName.trim();
            this.defaultAddress = featureData.defaultAddress;
        }
    }
}

export class labelLanguage{
    public th: String;
    public en: String;
  }



// WEBPACK FOOTER //
// ./src/app/model/feature/cost-center-feature.model.ts